import { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../author/author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

const EditEndpoint = ApiEndpoints.clientLogo.Edit;
const UpdateEndPoint = ApiEndpoints.clientLogo.Update;

export default function EditClientLogo() {
  const { clientlogo_id } = useParams();
  const navigate = useNavigate();

  const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    country: "",
    alt_logo: "",
    logo: null,
  });

  useEffect(() => {
    const dataFetch = async () => {
      try {
        const response = await ApiRequest("GET",`${EditEndpoint}${clientlogo_id}`);
        const result = response.logo;
        setFormData({country: result.country || "",image: null, alt_logo: result.alt_logo || ""});
        setPreviewImage(result.logo ? `${BaseUrl}/${result.logo}` : "");
      } catch (error) {
        console.error("Error fetching client logo data:", error);
      }
    };
    dataFetch();
  }, [clientlogo_id]);


  const handleChange = useCallback((event) => {
    const { name, value, type, files } = event.target;
    if (name === "logo" && type === "file") {
      const file = files[0];
      if (file) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewImage(objectUrl);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const payload = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key !== "logo") {
          payload.append(key, formData[key]);
        }
      });
      if (formData.logo) {
        payload.append("logo", formData.logo);
      }
      payload.append("logo_id", clientlogo_id);

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", UpdateEndPoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        toast.success(response.message)
        navigate("/admin/client-logos");
      } catch (error) {
        console.error("Error updating client logo:", error);
      }
    },
    [clientlogo_id, formData, navigate]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Edit Client Logo</h5>
      </div>
      <div className="add-author-content">
        <form onSubmit={handleSubmit}>
          <label>Country:*</label>
          <input name="country" value={formData.country} type="text" className="form-control" onChange={handleChange} required />

          <label>Image:(344 x 200 px)</label>
          <input name="logo" type="file" className="form-control" onChange={handleChange} />
          {previewImage && (
            <div style={{ width: "60px", height: "60px", margin: "10px 0", overflow: "hidden" }}>
              <img src={previewImage} alt="Preview" className="img-responsive" />
            </div>
          )}

          <label>Alt Image*:</label>
          <input value={formData.alt_logo} type="text" name="alt_logo" onChange={handleChange} className="form-control" required />

          <div className="submit-formbtn mt-4">
            <button type="submit" className="default-btn">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

